import { Component } from '@angular/core'
import { HeroCardComponent } from '../../../../shared/components/hero-card/hero-card.component';

@Component({
    selector: 'app-access',
    templateUrl: './access-denied.component.html',
    standalone: true,
    imports: [HeroCardComponent],
})
export class AccessDeniedComponent {}
